export const GET_DEPARTAMENTOS = 'GET_DEPARTAMENTOS'
export const GET_DEPARTAMENTO_ESPECIFICO = 'GET_DEPARTAMENTO_ESPECIFICO'
export const GET_OPERADORES = 'GET_OPERADORES'
export const GET_DEPARTAMENTO_USE = 'GET_DEPARTAMENTO_USE'
